/**
 * The project kick-off pack (docs/24 §3.1).
 *
 * "Project awarded: all documents uploaded regarding the project — drawings,
 * terms and conditions, procedures, approved drawings, and the TDS." Plus the
 * time line and the lead times. The readiness check answers one question
 * before the first order is placed: is everything a buyer needs to buy right
 * actually here?
 */

export const KICKOFF_ROLES = [
  'DRAWINGS', 'APPROVED_DRAWINGS', 'TERMS', 'PROCEDURES', 'TDS', 'TEST_CERTIFICATES',
] as const
export type KickoffRole = (typeof KICKOFF_ROLES)[number]

export const KICKOFF_ROLE_OPTIONS: ReadonlyArray<[KickoffRole, string]> = [
  ['DRAWINGS', 'Drawings'],
  ['APPROVED_DRAWINGS', 'Approved drawings'],
  ['TERMS', 'Terms and conditions'],
  ['PROCEDURES', 'Procedures and method statements'],
  ['TDS', 'Technical data sheets (TDS)'],
  ['TEST_CERTIFICATES', 'Test certificates'],
]

/** Where a drawing or a data sheet stands. */
export const APPROVAL_STATES = [
  ['FOR_REVIEW', 'For review'],
  ['APPROVED', 'Approved'],
  ['SUPERSEDED', 'Superseded'],
] as const satisfies ReadonlyArray<[string, string]>

export interface KickoffCheck {
  readonly key: string
  readonly label: string
  readonly ok: boolean
  /** One line saying what was found. */
  readonly detail: string
  /** What is missing, where there is a list to give. */
  readonly missing: readonly string[]
}

export interface KickoffReadiness {
  readonly projectId: string
  readonly checks: readonly KickoffCheck[]
  /** The share of checks that pass, out of 100. */
  readonly score: number
  /** False when the company has not set up the kick-off file categories yet. */
  readonly categoriesReady: boolean
}
